module.exports = __webpack_public_path__ + "static/media/play-stop-button.959cef1a.svg";